// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2v3YP","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__1mpdJ"};